







































import { Emit, Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { EventBus, TypeEventBus } from '../utils';

@Component({
    components: {}
})
export default class ContextMenu extends Vue {
    @Prop() clickedEvent: any;
    @Prop() items: any;
    @Prop() listSubHeader: any;
    @Prop() listDense: any;
    visible: boolean = false;
    elementToShow: HTMLFormElement;

    x: number = 0;
    y: number = 0;
    // items: any = [
    //     {
    //         title: 'style 1 title',
    //         menuAction: 'style 1'
    //     },
    //     {
    //         title: 'style 2 title',
    //         menuAction: action => { alert(action) }
    //     },
    //     {
    //         title: 'style 3 title',
    //         menuAction: action => { this.someFunc(action) }
    //     }
    // ];

    @Emit()
    closeMenu() {}

    @Watch('visible')
    watchVisible(val) {
        if (!val) {
            this.closeMenu();
        }
    }

    @Watch('clickedEvent')
    watchClickEvent(evt) {
        this.visible = false;
        if(evt && evt.clientX && evt.clientY){
            this.x = evt.clientX;
            this.y = evt.clientY;
            this.$nextTick(() => {
                this.visible = true;
            });
        }
    }

    elementToOpen(element) {
        this.$emit('element-to-open', element);
    }

    goToUrl(link) {
        if (link.target === '_blank') {
            let win = window.open(link.path, '_blank');
            if (win !== null) {
                win.focus();
            }
        } else {
            window.location.replace(link.path);
        }
    }

    clickItem(item) {
        if (item.openElement !== undefined) {
            this.elementToOpen(item.openElement);
        } else {
            if (item.link !== undefined) {
                this.goToUrl(item.link);
            } else {
                this.$emit(item.event.name, item.event.data);
                // EventBus.$emit(item.event.name, item.event.data);
            }
        }
    }
}
